import type { InventoryItemType } from '@/types/pos'

// ── Stock level status ─────────────────────────────────────────

export type StockStatus = 'critical' | 'low' | 'good' | 'overstocked'

export function getStockStatus(
  currentStock: number,
  parLevel: number,
): StockStatus {
  if (parLevel <= 0) return 'good'
  const ratio = currentStock / parLevel
  if (ratio < 0.25) return 'critical'
  if (ratio < 0.5) return 'low'
  if (ratio <= 1) return 'good'
  return 'overstocked'
}

// ── Item type labels ──────────────────────────────────────────

export const ITEM_TYPE_LABELS: Record<InventoryItemType, string> = {
  raw_material: 'Ingredient',
  finished_good: 'Finished Product',
  supply: 'Supply',
  packaging: 'Packaging',
  beverage: 'Beverage',
}
